import ky from 'ky';
import { ENV } from 'src/utils/env';

export interface EditInstallerNotesPromiseParam {
  display_id: string;
  zone_note_data: {
    last_updated: string;
    block_data: unknown;
  };
}

export const editInstallerNotesPromise = async (param: EditInstallerNotesPromiseParam) => {
  try {
    await ky
      .post(`${ENV.FRONTEND_API_URL}/edit_installer_notes`, {
        body: JSON.stringify(param),
      })
      .json();
  } catch (error) {
    console.error(error);
  }

  return true;
};
